import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle, AlertCircle, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function CoherencePanel({ operationId, onChange, onGoto, onState }) {
  const [coh, setCoh] = useState(null);
  const [op, setOp] = useState(null);

  const load = useCallback(() => {
    api.get(`/operations/${operationId}/coherence`).then((r) => { setCoh(r.data); onState && onState(r.data); });
    api.get(`/operations/${operationId}`).then((r) => setOp(r.data));
  }, [operationId, onState]);
  useEffect(load, [load]);

  const confirm = async (field, val) => {
    await api.post(`/operations/${operationId}/confirmations`, { [field]: val });
    toast.success("Confirmation enregistrée");
    load(); onChange && onChange();
  };

  if (!coh || !op) return <div className="mono">Analyse de cohérence…</div>;

  const bloquants = coh.checks.filter((c) => c.bloquant && !c.ok);

  return (
    <div className="card" data-testid="coherence-panel" style={{ borderLeft: `4px solid ${coh.bloque ? "var(--rouge)" : "var(--vert)"}` }}>
      <h3 style={{ fontSize: "1rem", marginBottom: 4 }}>Contrôle de cohérence</h3>
      <div style={{ fontSize: ".8rem", color: "var(--text-muted)", marginBottom: 10 }}>
        {coh.bloque
          ? `Le Plan de Prévention ne peut pas encore être généré : ${bloquants.length} élément(s) doivent être corrigés.`
          : "Tous les contrôles bloquants sont satisfaits : la génération est possible."}
      </div>

      {coh.bloque && (
        <div className="notice" data-testid="coh-blocking-list" style={{ background: "var(--rouge-p)", borderColor: "var(--rouge)", marginBottom: 12 }}>
          <b>{bloquants.length} point{bloquants.length > 1 ? "s" : ""} bloquant{bloquants.length > 1 ? "s" : ""} :</b>
          <ul className="qg-anomalies" style={{ marginTop: 8 }}>
            {bloquants.map((c) => (
              <li key={c.cle} data-testid={`coh-block-${c.cle}`}>
                <div>
                  <b>{c.label}</b>
                  <span className="qg-anom-etape">Étape : {c.lien} · Champ : {c.champ} · Rôle : {c.roleHabilite}</span>
                  {c.attendu ? <span className="qg-anom-msg">Condition attendue : {c.attendu}</span> : null}
                </div>
                <button className="btn btn-p btn-sm" data-testid={`coh-fix-${c.cle}`}
                  onClick={() => onGoto && onGoto(c.ongletIndex)} style={{ whiteSpace: "nowrap" }}>
                  Corriger <ArrowRight size={13} />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {coh.checks.map((c) => (
        <div className="ck" key={c.cle} data-testid={`coh-${c.cle}`} style={{ alignItems: "flex-start" }}>
          {c.ok ? <CheckCircle2 size={16} color="var(--vert)" style={{ marginTop: 2 }} />
            : c.bloquant ? <XCircle size={16} color="var(--rouge)" style={{ marginTop: 2 }} />
              : <AlertCircle size={16} color="var(--ambre-f)" style={{ marginTop: 2 }} />}
          <span><b>{c.label}</b>{!c.bloquant && <span className="tag" style={{ marginLeft: 6 }}>non bloquant</span>}<div style={{ fontSize: ".76rem", color: "var(--text-muted)" }}>{c.detail}</div></span>
        </div>
      ))}
      <div style={{ marginTop: 12, display: "flex", gap: 16, flexWrap: "wrap" }}>
        <label style={{ display: "flex", gap: 8, alignItems: "center", width: "auto", fontSize: ".82rem" }}>
          <input type="checkbox" style={{ width: "auto" }} checked={!!op.documentsObligatoiresPresents} data-testid="confirm-docs" onChange={(e) => confirm("documentsObligatoiresPresents", e.target.checked)} />
          Documents obligatoires présents
        </label>
        <label style={{ display: "flex", gap: 8, alignItems: "center", width: "auto", fontSize: ".82rem" }}>
          <input type="checkbox" style={{ width: "auto" }} checked={!!op.habilitationsControlees} data-testid="confirm-habil" onChange={(e) => confirm("habilitationsControlees", e.target.checked)} />
          Habilitations contrôlées
        </label>
      </div>
    </div>
  );
}
